package app.bloomey.web.core.data.models

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable
import kotlin.time.Duration

@Serializable
data class Video(
    @SerialName("_id")
    val id: String,
    val videoId: String,
    val title: String,
    val imageUrl: String,
    val categoryId: String,
    val duration: Duration,
    val provider: VideoProvider,
    val userId: String,
    val createdAt: Long,
    val watchPosition: Long,
    val watchedAt: Long,
)

enum class VideoProvider {
    youtube,
    local
}

@Serializable
data class UpdateVideoRequest(
    val videoId: String,
    val title: String,
    val imageUrl: String,
    val categoryId: String,
    val duration: Duration,
    val provider: VideoProvider,
)